export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-950">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-black text-background-100 mb-3">
            爆料投稿 &amp; 商务联系
          </h2>
          <p className="text-secondary-400 text-sm md:text-base">你的每一条线索，都可能是下一个重磅猛料</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 max-w-4xl mx-auto">
          <div className="flex-1 space-y-5">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-500/15 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-background-100 font-bold text-sm mb-0.5">匿名投稿邮箱</h3>
                <p className="text-secondary-400 text-sm">tips@baoliaowang.com</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-500/15 flex items-center justify-center shrink-0">
                <i className="ri-shield-check-line text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-background-100 font-bold text-sm mb-0.5">安全投稿通道</h3>
                <p className="text-secondary-400 text-sm">全部投稿采用端到端加密，不留存IP与个人信息</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-500/15 flex items-center justify-center shrink-0">
                <i className="ri-briefcase-line text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-background-100 font-bold text-sm mb-0.5">商务合作</h3>
                <p className="text-secondary-400 text-sm">bd@baoliaowang.com</p>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="space-y-4">
              <div className="border-b border-white/10 pb-2">
                <input
                  type="text"
                  placeholder="你的昵称或匿名代号"
                  readOnly
                  className="w-full bg-transparent text-background-100 text-sm py-2 outline-none placeholder:text-white/25"
                />
              </div>
              <div className="border-b border-white/10 pb-2">
                <textarea
                  placeholder="写下你想爆料的独家内容..."
                  readOnly
                  rows={4}
                  className="w-full bg-transparent text-background-100 text-sm py-2 outline-none resize-none placeholder:text-white/25"
                ></textarea>
              </div>
              <div className="flex items-center justify-end">
                <button
                  type="button"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 hover:bg-accent-600 text-white text-sm font-semibold rounded-full transition-colors whitespace-nowrap"
                >
                  安全投递
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
              <p className="text-white/20 text-xs leading-relaxed">
                提交即表示你同意我们的
                <a href="#faq" className="underline underline-offset-2 hover:text-white/40 transition-colors">投稿规则</a>
                与
                <a href="#faq" className="underline underline-offset-2 hover:text-white/40 transition-colors">隐私政策</a>
                。我们承诺严格保护投稿人信息安全，所有通信均加密传输。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}